// extracted by mini-css-extract-plugin
export default {"cls1":"ISGhvVN3DrEtQojlL2qI","cls2":"t96RG0qz_Jk4ogEyxfqD ISGhvVN3DrEtQojlL2qI"};